import { Dialog } from "@mui/material";
import React from "react";

const DialogComponent = ({ open, onClose, children }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      {children}
    </Dialog>
  );
};

export default DialogComponent;
